export default {
  apiVersion: 2,
  development: {
    accessToken: '110ef21c9604156a6fc54d6c86843b69',
    url: 'http://api.curry.dev.moya.is/_/moya/pilot/api',
  },
  staging: {
    accessToken: '110ef21c9604156a6fc54d6c86843b69',
    url: 'https://api.indiancurryhouse.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '110ef21c9604156a6fc54d6c86843b69',
    url: 'https://api.indiancurryhouse.is/_/moya/pilot/api',
  },
};
